<app-form-input-wrapper [label]="label" [control]="formControl">
  @if (variant === 'textfield') {
    <input
      [attr.disabled]="isDisabled ? true : null"
      [attr.autocomplete]="autocomplete ? autocomplete : null"
      [attr.name]="autocomplete === 'email' ? 'email' : null"
      [value]="value"
      (input)="valueChanged(inputElement.value)"
      #inputElement
      appTailwindInput2
      [control]="formControl"
      type="text"
      />
  }
  @if (variant === 'textarea') {
    <textarea
      [attr.disabled]="isDisabled ? true : null"
      [value]="value"
      (input)="valueChanged(inputElement.value)"
      #inputElement
      appTailwindInput2
      [control]="formControl"
      type="text"
    ></textarea>
  }
</app-form-input-wrapper>
